import assetAyLogoWhiteTransp from './ay-logo-white-transp.svg';
export enum TransparentLogoIconName {
  TransparentAboutYouLogo = 'TransparentAboutYouLogo',
}

export const transparentLogoIconAssets: {
  [key in TransparentLogoIconName]: string;
} = {
  [TransparentLogoIconName.TransparentAboutYouLogo]: assetAyLogoWhiteTransp,
};
